import { Button, Circle } from '@wegroup/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import useSessionId from '../../../../../../flows/src/hooks/useSessionId';
import { useLouiseSelector } from '../../../../store/redux/store';
import useIsSelectedOffersPage from '../../hooks/useIsSelectedOffersPage';
import useOffersPageParams from '../../hooks/useOffersPageParams';

const OffersSidebarSelectedOffersButton: React.FC = () => {
  const { t } = useTranslation();
  const { page } = useOffersPageParams();
  const sessionId = useSessionId();

  const isSelectedOffersPage = useIsSelectedOffersPage();
  const selectedOffers = useLouiseSelector(
    (state) => state.offers.selectedOffers,
  );

  const getOfferCount = () => {
    let count = 0;
    Object.values(selectedOffers).forEach((offer) => {
      count = count + offer.length;
    });
    return count;
  };

  const offerCount = getOfferCount();

  return (
    <Button
      as={Link}
      borderRadius="full"
      w="full"
      rightIcon={
        offerCount && !isSelectedOffersPage ? (
          <Circle size="5" color="primary.500" bg="white" textStyle="smallBody">
            {offerCount}
          </Circle>
        ) : undefined
      }
      to={`/sales-conversation/offers/selected-offers?session_id=${sessionId}`}
      isDisabled={page === 'selected-offers'}
    >
      {t('Your selected offers')}
    </Button>
  );
};

export default OffersSidebarSelectedOffersButton;
